import useIsClientSide from './useIsClientSide';

export interface ShareContent {
    url: string;
    text: string;
    title: string;
}

/**
 * Checks if native share is available and returns a callback to share items
 */
export default function useNativeShare(): [
    boolean,
    (data: ShareContent, success?: () => void, error?: () => void) => void,
] {
    const isClient = useIsClientSide();

    const openNativeShare = (data: ShareContent, success?: () => void, error?: () => void) => {
        navigator
            .share(data)
            .then(() => success && success())
            .catch(() => error && error());
    };

    return [isClient && Boolean(navigator.share), openNativeShare];
}
